import React from "react";

const CodeBlock = ({ children }) => {
  const codeString = String(children)
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  const copyToClipboard = () => {
    navigator.clipboard.writeText(String(children));
  };

  return (
    <div className="relative bg-gray-900 text-white p-4 rounded-lg">
      <pre className="overflow-x-auto">
        <code dangerouslySetInnerHTML={{ __html: codeString }} />
      </pre>
      <button
        onClick={copyToClipboard}
        className="absolute top-2 right-2 bg-gray-700 px-2 py-1 rounded text-sm hover:bg-gray-600"
      >
        Copiar
      </button>
    </div>
  );
};

export default CodeBlock;
